import React from "react";

import { useModalities } from "@/shared/hooks/useModalities";
import { findModalityByAbbr } from "@/shared/schemas/modalities";

/**
 * Hook personalizado para obtener el nombre de una modalidad específica
 * @param modalityAbbr - La abreviación de la modalidad
 * @param language - El idioma deseado
 * @returns El nombre de la modalidad o la abreviación si no se encuentra
 */
export function useModalityName(modalityAbbr: string, language: "en" | "es" = "es") {
  const { data: modalities, isLoading, error, isSuccess } = useModalities();

  const modalityName = React.useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!modalities || isLoading || error) {
      return modalityAbbr;
    }
    return findModalityByAbbr(modalities, modalityAbbr)?.name[language];
  }, [modalities, modalityAbbr, language, isLoading, error]);

  return {
    modalityName,
    isLoading,
    error,
    isSuccess,
  };
}
